import React from "react";
import { ActivityItem } from "../../types";
import { Bell, DollarSign, MessageSquare, Settings } from "lucide-react";

interface RecentActivityProps {
  data: ActivityItem[];
  type?: string; 
}

export const RecentActivity: React.FC<RecentActivityProps> = ({ data }) => {
  const getIcon = (type: ActivityItem["type"]) => {
    switch (type) {
      case "new":
        return <MessageSquare className="w-4 h-4 text-blue-500" />;
      case "alert":
        return <Bell className="w-4 h-4 text-red-500" />;
      case "revenue":
        return <DollarSign className="w-4 h-4 text-green-500" />;
      case "system":
        return <Settings className="w-4 h-4 text-gray-500" />;
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Recent Activity
      </h3>
      <div className="space-y-4">
        {/* {data.map((activity, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className={`p-2 rounded-lg ${getBgColor(activity.type)}`}>
              {getIcon(activity.type)}
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900">
                {activity.message}
              </p>
              <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
            </div>
          </div>
        ))} */}
        No Rcent Activities
      </div>
    </div>
  );
};
